/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IModuleProps } from '@msdyn365-commerce-modules/utilities';
import { SearchArea } from '@msdyn365-commerce/retail-proxy';
import { getStoreLocationsAction, GetStoreLocationsInput } from '../../data-actions/store-locations/get-store-locations';


import { ICittaStoreLocationMobileData } from './citta-store-location-mobile.data';
import { ICittaStoreLocationMobileProps, storeName } from './citta-store-location-mobile.props.autogenerated';

import { IDXC_StoreLocations } from '../../data-actions/generated/DataServiceEntities.g';


interface CittaStoreLocationMobileState {
    allStores: IDXC_StoreLocations[] | undefined;

}

export interface ICittaStoreLocationMobileViewProps extends ICittaStoreLocationMobileProps<ICittaStoreLocationMobileData> {
    storName: string
    CittaStoreDetail: React.ReactNode;
    CittaStores: IModuleProps;
    getcittaStore: IDXC_StoreLocations;
    storename: storeName;
    StoreDetail: IDXC_StoreLocations
}

/**
 *
 * CittaStoreLocationMobile component
 * @extends {React.PureComponent<ICittaStoreLocationMobileProps<ICittaStoreLocationMobileData>>}
 */
class CittaStoreLocationMobile extends React.PureComponent<ICittaStoreLocationMobileProps<ICittaStoreLocationMobileData>, CittaStoreLocationMobileState> {

    private resources = {
        store_stockistOfHeading: this.props.resources.store_stockistOfHeading || 'Stockists of',
        store_storeHoursHeading: this.props.resources.store_storeHoursHeading || 'Store Hours',
        store_storeHoursMonday: this.props.resources.store_storeHoursMonday || 'Monday',
        store_storeHoursTuesday: this.props.resources.store_storeHoursTuesday || 'Tuesday',
        store_storeHoursWednesday: this.props.resources.store_storeHoursWednesday || 'Wednesday',
        store_storeHoursThursday: this.props.resources.store_storeHoursThursday || 'Thursday',
        store_storeHoursFriday: this.props.resources.store_storeHoursFriday || 'Friday',
        store_storeHoursSaturday: this.props.resources.store_storeHoursSaturday || 'Saturday',
        store_storeHoursSunday: this.props.resources.store_storeHoursSunday || 'Sunday',
        store_storeHoursClosed: this.props.resources.store_storeHoursClosed || 'Closed',

    };

    constructor(props: ICittaStoreLocationMobileProps<ICittaStoreLocationMobileData>) {
        super(props);
        this.state = {
            allStores: [],
        };
        this._renderStoreDetail = this._renderStoreDetail.bind(this)

    }


    public async componentDidMount(): Promise<void> {
        const inputObj: SearchArea = {};
        // console.log(111,inputObj)
        if (navigator && navigator.geolocation) {
            // tslint:disable-next-line: no-this-assignment
            const that = this;
            navigator.geolocation.getCurrentPosition(
                position => {
                    inputObj.Latitude = position.coords.latitude ? position.coords.latitude : 0; // -36.84403
                    inputObj.Longitude = position.coords.longitude ? position.coords.longitude : 0; // 174.76008
                    inputObj.Radius = 100; // position.coords.accuracy;
                    inputObj.DistanceUnitValue = 0; // position.coords.altitudeAccuracy!;
                    // tslint:disable-next-line: no-floating-promises
                    getStoreLocationsAction(new GetStoreLocationsInput(inputObj), this.props.context.actionContext).then(
                        (result) => {
                            this.setState({
                                allStores: result.storeLocations && result.storeLocations.length > 1? result.storeLocations : storeLocationsBackUp,
                            });
                        });
                },
                error => {
                    if (error.code === error.PERMISSION_DENIED) {
                        inputObj.Latitude = 0; // -36.84403
                        inputObj.Longitude = 0; // 174.76008
                        inputObj.Radius = 100; // position.coords.accuracy;
                        inputObj.DistanceUnitValue = 0; // position.coords.altitudeAccuracy!;
                        getStoreLocationsAction(new GetStoreLocationsInput(inputObj), that.props.context.actionContext).then(
                            (result) => {
                                that.setState({
                                    allStores: result.storeLocations && result.storeLocations.length > 1? result.storeLocations : storeLocationsBackUp,
                                    // stores: result.nearMeStoreLocations
                                });
                            })
                            .catch(() => {
                                console.log('No data');
                            });
                    }
                });
        }
    }

    public render(): JSX.Element | null {

        const ViewProp = {
            ...this.props,

            storename: this.props.config.storeName,
            CittaStores: {
                moduleProps: this.props,
                className: 'citta-stores-mobile'
            },
            CittaStoreLocations: {
                className: 'citta-store-locations',
                role: 'menu'
            },
            StoreDetail: this._renderStoreDetail()

        }

        return this.props.renderView(ViewProp);
    }

    private _renderStoreDetail(): React.ReactNode {

        const _renderInfo = (index: number): JSX.Element => {
            const allstores = this.state.allStores && this.state.allStores[index];
            const streetaddress: '' | string[] | undefined = allstores && allstores.address && allstores.address.split('\n');
            if (streetaddress) {
                streetaddress.pop();
                if (streetaddress.length < 4) {
                    streetaddress.push('NZL')
                }
            }
            const stockistsOf: '' | string[] | undefined = allstores && allstores.stockistOf && allstores.stockistOf.split('\n');
            const stockistOfStr: '' | string | undefined = stockistsOf && stockistsOf.join(", ");
            const storemainimagemobile: '' | string | undefined = this.props.config.storeMainImageMobie.find(storemainImageString => storemainImageString.startsWith(allstores?.storName || 'undefined'));
            const googlemaplinkmobile: '' | string | undefined = this.props.config.googleMapLinkMobile.find(googleMapLink => googleMapLink.startsWith(allstores?.storName || 'undefined'));
            const storeHoursMondayBackUpMobile: '' | string | undefined = this.props.config.storeHoursMondayBackUpMobile?.find(str => str.startsWith(allstores?.storName || 'undefined'));
            const storeHoursTuesdayBackUpMobile: '' | string | undefined = this.props.config.storeHoursTuesdayBackUpMobile?.find(str => str.startsWith(allstores?.storName || 'undefined'));
            const storeHoursWednesdayBackUpMobile: '' | string | undefined = this.props.config.storeHoursWednesdayBackUpMobile?.find(str => str.startsWith(allstores?.storName || 'undefined'));
            const storeHoursThursdayBackUpMobile: '' | string | undefined = this.props.config.storeHoursThursdayBackUpMobile?.find(str => str.startsWith(allstores?.storName || 'undefined'));
            const storeHoursFridayBackUpMobile: '' | string | undefined = this.props.config.storeHoursFridayBackUpMobile?.find(str => str.startsWith(allstores?.storName || 'undefined'));
            const storeHoursSaturdayBackUpMobile: '' | string | undefined = this.props.config.storeHoursSaturdayBackUpMobile?.find(str => str.startsWith(allstores?.storName || 'undefined'));
            const storeHoursSundayBackUpMobile: '' | string | undefined = this.props.config.storeHoursSundayBackUpMobile?.find(str => str.startsWith(allstores?.storName || 'undefined'));
            return (
                <div className="citta-store-location-mobile">
                    <div className="store-location-mobile-hero">
                        <img src={storemainimagemobile?.split('|')[1]} alt="" />
                    </div>
                    <div className="citta-store-location-content">
                        <div className="store-location-title">{allstores?.storName || " "}</div>
                        <div className="store-location-address">
                            {streetaddress && streetaddress.map((addressline: string, indexadd: number) =>
                            (<div className={`citta-store-address-${indexadd}`} key={indexadd}>
                                {addressline}
                            </div>
                            ))}
                        </div>
                        <div className='citta-store-phone'>
                            <p className='citta-store-phone-text'>phone:</p>
                            <a className='citta-store-phone-number' href={`tel:${allstores?.phone}`}>{allstores?.phone}</a>
                        </div>
                        <div className='citta-store-email'>
                            <p>email:</p>
                            <a className='citta-store-email-link' href={`mailto:${allstores?.emailAddress}`}>{allstores?.emailAddress}</a>
                        </div>
                        <div className="citta-store-storeHours">
                            <div className='citta-store-storeHours-heading'>
                                {this.resources.store_storeHoursHeading}
                            </div>
                            {allstores && allstores.storeHours && this._renderStore(storeHoursMondayBackUpMobile?.split('|')[1] === "true" || allstores.storeHours.IsClosedOnMonday!, this.resources.store_storeHoursMonday, Number(storeHoursMondayBackUpMobile?.split('|')[2])*3600 || allstores.storeHours.MondayOpenTime!, Number(storeHoursMondayBackUpMobile?.split('|')[3])*3600 || allstores.storeHours.MondayCloseTime!, storeHoursMondayBackUpMobile?.split('|')[4] || '')}
                            {allstores && allstores.storeHours && this._renderStore(storeHoursTuesdayBackUpMobile?.split('|')[1] === "true" || allstores.storeHours.IsClosedOnTuesday!, this.resources.store_storeHoursTuesday, Number(storeHoursTuesdayBackUpMobile?.split('|')[2])*3600 || allstores.storeHours.TuesdayOpenTime!, Number(storeHoursTuesdayBackUpMobile?.split('|')[3])*3600 || allstores.storeHours.TuesdayCloseTime!, storeHoursTuesdayBackUpMobile?.split('|')[4] || '')}
                            {allstores && allstores.storeHours && this._renderStore(storeHoursWednesdayBackUpMobile?.split('|')[1] === "true" || allstores.storeHours.IsClosedOnWednesday!, this.resources.store_storeHoursWednesday, Number(storeHoursWednesdayBackUpMobile?.split('|')[2])*3600 || allstores.storeHours.WednesdayOpenTime!, Number(storeHoursWednesdayBackUpMobile?.split('|')[3])*3600 || allstores.storeHours.WednesdayCloseTime!, storeHoursWednesdayBackUpMobile?.split('|')[4] || '')}
                            {allstores && allstores.storeHours && this._renderStore(storeHoursThursdayBackUpMobile?.split('|')[1] === "true" || allstores.storeHours.IsClosedOnThursday!, this.resources.store_storeHoursThursday, Number(storeHoursThursdayBackUpMobile?.split('|')[2])*3600 || allstores.storeHours.ThursdayOpenTime!, Number(storeHoursThursdayBackUpMobile?.split('|')[3])*3600 || allstores.storeHours.ThursdayCloseTime!, storeHoursThursdayBackUpMobile?.split('|')[4] || '')}
                            {allstores && allstores.storeHours && this._renderStore(storeHoursFridayBackUpMobile?.split('|')[1] === "true" || allstores.storeHours.IsClosedOnFriday!, this.resources.store_storeHoursFriday, Number(storeHoursFridayBackUpMobile?.split('|')[2])*3600 || allstores.storeHours.FridayOpenTime!, Number(storeHoursFridayBackUpMobile?.split('|')[3])*3600 || allstores.storeHours.FridayCloseTime!, storeHoursFridayBackUpMobile?.split('|')[4] || '')}
                            {allstores && allstores.storeHours && this._renderStore(storeHoursSaturdayBackUpMobile?.split('|')[1] === "true" || allstores.storeHours.IsClosedOnSaturday!, this.resources.store_storeHoursSaturday, Number(storeHoursSaturdayBackUpMobile?.split('|')[2])*3600 || allstores.storeHours.SaturdayOpenTime!, Number(storeHoursSaturdayBackUpMobile?.split('|')[3])*3600 || allstores.storeHours.SaturdayCloseTime!, storeHoursSaturdayBackUpMobile?.split('|')[4] || '')}
                            {allstores && allstores.storeHours && this._renderStore(storeHoursSundayBackUpMobile?.split('|')[1] === "true" || allstores.storeHours.IsClosedOnSunday!, this.resources.store_storeHoursSunday, Number(storeHoursSundayBackUpMobile?.split('|')[2])*3600 || allstores.storeHours.SundayOpenTime!, Number(storeHoursSundayBackUpMobile?.split('|')[3])*3600 || allstores.storeHours.SundayCloseTime!, storeHoursSundayBackUpMobile?.split('|')[4] || '')}
                        </div>
                        <div className='citta-store-location-notes'>
                            {allstores?.locationNotes}
                        </div>
                        <div className="citta-store-map">
                            <div className='citta-store-location-map'>
                                <iframe src={googlemaplinkmobile?.split('|')[1]} width="800" height="200" style={{ border: 0 }} ></iframe>
                            </div>
                            <div>
                                <a className='citta-store-map-link' href={allstores?.googleMapLink ? allstores?.googleMapLink : '#'} target='_blank'>Get directions &gt;</a>
                            </div>
                        </div>
                        <div className='citta-store-stockistsof'>
                            <div className='citta-store-stockistsof-content'>
                                <div>
                                    {`Our ${allstores?.storName} store stocks ${stockistOfStr}.`}
                                </div>
                            </div>
                        </div>
                        <div className="citta-store-location-end">{"Click & collect available during store hours."}</div>
                    </div>
                </div>
            )
        }



        switch (this.props.config.storeName) {
            case 'citta_BLOC':
                return (
                    <div>{_renderInfo(0)}</div>
                );
            case 'citta_Essentials_Christchurch':
                return (
                    <div>{_renderInfo(7)}</div>
                );
            case 'citta_Essentials_Glen_Innes':
                return (
                    <div>{_renderInfo(9)}</div>
                );
            case 'citta_Essentials_Mount_Eden':
                return (
                    <div>{_renderInfo(1)}</div>
                );
            case 'citta_Essentials_North_Shore':
                return (
                    <div>{_renderInfo(5)}</div>
                );
            // case 'citta_Essentials_Wellington':
            //     return (
            //         <div>{_renderInfo(6)}</div>
            //     );
            case 'citta_Grey_Lynn':
                return (
                    <div>{_renderInfo(2)}</div>
                );
            case 'citta_Hamilton':
                return (
                    <div>{_renderInfo(3)}</div>
                );
            case 'citta_Merivale':
                return (
                    <div>{_renderInfo(8)}</div>
                );
            // case 'citta_Newmarket':
            //     return (
            //         <div>{_renderInfo(9)}</div>
            //     );
            case 'citta_Takapuna':
                return (
                    <div>{_renderInfo(4)}</div>
                );
            case 'citta_Wellington_Thorndon':
                return (
                    <div>{_renderInfo(6)}</div>
                );
            default:
                return (
                    <div>''</div>
                )
        }


    }


    private _renderStore(isClosed: boolean, day: string, openTime: number, closeTime: number, holiday: string): JSX.Element | null {
        const openFrom: string | undefined = this._secondsToTime(openTime);
        const openTo: string | undefined = this._secondsToTime(closeTime);
        return (
            <div>
                {isClosed ?
                    <div className='citta-store-storeHours-content'>
                        <div className='citta-store-storeHours-content-day'> {day}</div>
                        <div className='citta-store-storeHours-content-hours'>{this.resources.store_storeHoursClosed} {holiday}</div>
                    </div> :
                    <div className='citta-store-storeHours-content'>
                        <div className='citta-store-storeHours-content-day'> {day}</div>
                        <div className='citta-store-storeHours-content-hours'>{openFrom} - {openTo} {holiday}</div>
                    </div>}
            </div>
        );
    }

    private _secondsToTime = (seconds: number | undefined): string | undefined => {
        if (seconds === undefined) {
            return undefined;
        } else {
            let hours = Math.floor(seconds / (60 * 60));
            const ampm = hours >= 12 ? 'pm' : 'am';
            hours = hours % 12;
            hours = hours ? hours : 12;
            const divisorForMinutes = seconds % (60 * 60);
            const minutes =
                Math.floor(divisorForMinutes / 60) < 10 ? `0${Math.floor(divisorForMinutes / 60)}` : Math.floor(divisorForMinutes / 60);
            return `${hours}.${minutes} ${ampm}`;
        }
    };

}

let storeLocationsBackUp  : IDXC_StoreLocations[] | undefined = [
    {
        storName: "Città BLOC",
        address: `BLOC, Level 1
        20 Normanby Road
        Mount Eden
        Auckland 1024
        NZL`,
        phone: "09 929 1617",
        emailAddress: "mteden@cittadesign.com",
        locationNotes:"*Customer parking off Enfield Street",
        stockistOf:`Anglepoise
        Artek
        Città
        Compagnie De Provence
        Korbo
        Nude
        Stelton
        Vitra`,
        googleMapLink: "https://goo.gl/maps/hX8WfZUAsjDmA7E16",
        storeHours:{
         MondayOpenTime: 32400,
         MondayCloseTime: 61200,
         IsClosedOnMonday: false,
         TuesdayOpenTime: 32400,
         TuesdayCloseTime: 61200,
         IsClosedOnTuesday: false,
         WednesdayOpenTime: 32400,
         WednesdayCloseTime: 61200,
         IsClosedOnWednesday: false,
         ThursdayOpenTime: 32400,
         ThursdayCloseTime: 61200,
         IsClosedOnThursday: false,
         FridayOpenTime: 32400,
         FridayCloseTime: 61200,
         IsClosedOnFriday: false,
         SaturdayOpenTime: 32400,
         SaturdayCloseTime: 61200,
         IsClosedOnSaturday: false,
         SundayOpenTime: 36000,
         SundayCloseTime: 57600,
         IsClosedOnSunday: false,
         ExtensionProperties: undefined,
     }
     },
     {
        storName: "Città Essentials Mount Eden",
        address: `18 Normanby Road
        Mount Eden
        Auckland 1024
        NZL`,
        phone: "09 623 9882",
        emailAddress: "mteden@cittaessentials.com",
        locationNotes:undefined,
        stockistOf:`Città
        Città Essentials
        Compagnie De Provence
        Duralex
        Nude`,
        googleMapLink: "https://goo.gl/maps/9WpVnGqMksTDA2516",
        storeHours:{
         MondayOpenTime: 36000,
         MondayCloseTime: 57600,
         IsClosedOnMonday: false,
         TuesdayOpenTime: 36000,
         TuesdayCloseTime: 57600,
         IsClosedOnTuesday: false,
         WednesdayOpenTime: 36000,
         WednesdayCloseTime: 57600,
         IsClosedOnWednesday: false,
         ThursdayOpenTime: 36000,
         ThursdayCloseTime: 57600,
         IsClosedOnThursday: false,
         FridayOpenTime: 36000,
         FridayCloseTime: 57600,
         IsClosedOnFriday: false,
         SaturdayOpenTime: 36000,
         SaturdayCloseTime: 57600,
         IsClosedOnSaturday: false,
         SundayOpenTime: 36000,
         SundayCloseTime: 57600,
         IsClosedOnSunday: false,
         ExtensionProperties: undefined,
     }
      },
      {
        storName: "Città Grey Lynn",
        address: `Westmoreland Shops
        274 Richmond Road (access from Westmoreland St West)
        Grey Lynn
        Auckland 1021
        NZL`,
        phone: "09 972 9293",
        emailAddress: "greylynn@cittadesign.com",
        locationNotes:undefined,
        stockistOf:`Artek
        Asili
        Città
        Città Essentials
        Compagnie De Provence
        Duralex
        Korbo
        Nodi
        Nude
        Stelton
        Vitra`,
        googleMapLink: "https://maps.app.goo.gl/LDQZPuUdg4gmXiDeA",
        storeHours:{
         MondayOpenTime: 32400,
         MondayCloseTime: 61200,
         IsClosedOnMonday: false,
         TuesdayOpenTime: 32400,
         TuesdayCloseTime: 61200,
         IsClosedOnTuesday: false,
         WednesdayOpenTime: 32400,
         WednesdayCloseTime: 61200,
         IsClosedOnWednesday: false,
         ThursdayOpenTime: 32400,
         ThursdayCloseTime: 61200,
         IsClosedOnThursday: false,
         FridayOpenTime: 32400,
         FridayCloseTime: 61200,
         IsClosedOnFriday: false,
         SaturdayOpenTime: 36000,
         SaturdayCloseTime: 61200,
         IsClosedOnSaturday: false,
         SundayOpenTime: 36000,
         SundayCloseTime: 57600,
         IsClosedOnSunday: false,
         ExtensionProperties: undefined,
     }
      },
      {
        storName: "Città Hamilton",
        address: `Made Hamilton
        401 Grey Street
        Hamilton East
        Hamilton 3216
        NZL`,
        phone: "07 929 4027",
        emailAddress: "hamilton@cittadesign.com",
        locationNotes:undefined,
        stockistOf:`Artek
        Asili
        Città
        Città Essentials
        Compagnie De Provence
        Duralex
        Korbo
        Nodi
        Nude
        Stelton
        Vitra`,
        googleMapLink: "https://maps.app.goo.gl/3SJzHaDnMuvK83AeA",
        storeHours:{
         MondayOpenTime: 32400,
         MondayCloseTime: 61200,
         IsClosedOnMonday: false,
         TuesdayOpenTime: 32400,
         TuesdayCloseTime: 61200,
         IsClosedOnTuesday: false,
         WednesdayOpenTime: 32400,
         WednesdayCloseTime: 61200,
         IsClosedOnWednesday: false,
         ThursdayOpenTime: 32400,
         ThursdayCloseTime: 61200,
         IsClosedOnThursday: false,
         FridayOpenTime: 32400,
         FridayCloseTime: 61200,
         IsClosedOnFriday: false,
         SaturdayOpenTime: 32400,
         SaturdayCloseTime: 61200,
         IsClosedOnSaturday: false,
         SundayOpenTime: 32400,
         SundayCloseTime: 57600,
         IsClosedOnSunday: false,
         ExtensionProperties: undefined,
     }
      },
      {
        storName: "Città Takapuna",
        address: `Shop 2, 6-10 Como Street
        Takapuna
        Auckland 0622
        NZL`,
        phone: "09 972 9147",
        emailAddress: "takapuna@cittadesign.com",
        locationNotes:undefined,
        stockistOf:`Artek
        Città
        Città Essentials
        Compagnie De Provence
        Korbo
        Nude
        Stelton
        Vitra`,
        googleMapLink: "https://goo.gl/maps/S534kU3XiZNmi9vDA",
        storeHours:{
         MondayOpenTime: 32400,
         MondayCloseTime: 61200,
         IsClosedOnMonday: false,
         TuesdayOpenTime: 32400,
         TuesdayCloseTime: 61200,
         IsClosedOnTuesday: false,
         WednesdayOpenTime: 32400,
         WednesdayCloseTime: 61200,
         IsClosedOnWednesday: false,
         ThursdayOpenTime: 32400,
         ThursdayCloseTime: 61200,
         IsClosedOnThursday: false,
         FridayOpenTime: 32400,
         FridayCloseTime: 61200,
         IsClosedOnFriday: false,
         SaturdayOpenTime: 36000,
         SaturdayCloseTime: 61200,
         IsClosedOnSaturday: false,
         SundayOpenTime: 36000,
         SundayCloseTime: 57600,
         IsClosedOnSunday: false,
         ExtensionProperties: undefined,
     }
      },
      {
        storName: "Città Essentials North Shore",
        address: `7D Triton Drive
        Albany
        Auckland 0632
        NZL`,
        phone: "09 478 9994",
        emailAddress: "northshore@cittaessentials.com",
        locationNotes:undefined,
        stockistOf:`Città
        Città Essentials
        Compagnie De Provence
        Duralex
        Nude`,
        googleMapLink: "https://goo.gl/maps/ow3tmtT36r6K83gQ7",
        storeHours:{
            MondayOpenTime: 36000,
            MondayCloseTime: 57600,
            IsClosedOnMonday: false,
            TuesdayOpenTime: 36000,
            TuesdayCloseTime: 57600,
            IsClosedOnTuesday: false,
            WednesdayOpenTime: 36000,
            WednesdayCloseTime: 57600,
            IsClosedOnWednesday: false,
            ThursdayOpenTime: 36000,
            ThursdayCloseTime: 57600,
            IsClosedOnThursday: false,
            FridayOpenTime: 36000,
            FridayCloseTime: 57600,
            IsClosedOnFriday: false,
            SaturdayOpenTime: 36000,
            SaturdayCloseTime: 57600,
            IsClosedOnSaturday: false,
            SundayOpenTime: 36000,
            SundayCloseTime: 57600,
            IsClosedOnSunday: false,
            ExtensionProperties: undefined,
     }
      },
     
      {
        storName: "Città Wellington Thorndon",
        address: `Woolstore Design Centre
        258 Thorndon Quay
        Pipitea
        Wellington 6011
        NZL`,
        phone: "04 473 7075",
        emailAddress: "thorndon@cittadesign.com",
        locationNotes:undefined,
        stockistOf:`Artek
        Città
        Compagnie De Provence
        Korbo
        Nude
        Stelton
        Vitra`,
        googleMapLink: "https://goo.gl/maps/6pht3DrDQVRW2myS7",
        storeHours:{
         MondayOpenTime: 32400,
         MondayCloseTime: 61200,
         IsClosedOnMonday: false,
         TuesdayOpenTime: 32400,
         TuesdayCloseTime: 61200,
         IsClosedOnTuesday: false,
         WednesdayOpenTime: 32400,
         WednesdayCloseTime: 61200,
         IsClosedOnWednesday: false,
         ThursdayOpenTime: 32400,
         ThursdayCloseTime: 61200,
         IsClosedOnThursday: false,
         FridayOpenTime: 32400,
         FridayCloseTime: 61200,
         IsClosedOnFriday: false,
         SaturdayOpenTime: 36000,
         SaturdayCloseTime: 61200,
         IsClosedOnSaturday: false,
         SundayOpenTime: 36000,
         SundayCloseTime: 57600,
         IsClosedOnSunday: false,
         ExtensionProperties: undefined,
     }
      },
     {
        storName: "Città Essentials Christchurch",
        address: `752 Main North Road
        Belfast
        Christchurch 8052
        NZL`,
        phone: "03 323 9878",
        emailAddress: "christchurch@cittaessentials.com",
        locationNotes:undefined,
        stockistOf:`Città
        Città Essentials
        Compagnie De Provence
        Duralex
        Nude`,
        googleMapLink: "https://goo.gl/maps/hWL4apQ77GvGtnz59",
        storeHours:{
            MondayOpenTime: 36000,
            MondayCloseTime: 57600,
            IsClosedOnMonday: false,
            TuesdayOpenTime: 36000,
            TuesdayCloseTime: 57600,
            IsClosedOnTuesday: false,
            WednesdayOpenTime: 36000,
            WednesdayCloseTime: 57600,
            IsClosedOnWednesday: false,
            ThursdayOpenTime: 36000,
            ThursdayCloseTime: 57600,
            IsClosedOnThursday: false,
            FridayOpenTime: 36000,
            FridayCloseTime: 57600,
            IsClosedOnFriday: false,
            SaturdayOpenTime: 36000,
            SaturdayCloseTime: 57600,
            IsClosedOnSaturday: false,
            SundayOpenTime: 36000,
            SundayCloseTime: 57600,
            IsClosedOnSunday: false,
            ExtensionProperties: undefined,
     }
      },
      {
        storName: "Città Merivale",
        address: `12 Papanui Road
        Merivale
        Christchurch 8014
        NZL`,
        phone: "03 595 0482",
        emailAddress: "merivale@cittadesign.com",
        locationNotes:"*Customer parking off Derby Street",
        stockistOf:`Artek
        Città
        Città Essentials
        Compagnie De Provence
        Korbo
        Nude
        Stelton
        Vitra`,
        googleMapLink: "https://goo.gl/maps/FonTM2TCBckA6Z5b8",
        storeHours:{
         MondayOpenTime: 32400,
         MondayCloseTime: 61200,
         IsClosedOnMonday: false,
         TuesdayOpenTime: 32400,
         TuesdayCloseTime: 61200,
         IsClosedOnTuesday: false,
         WednesdayOpenTime: 32400,
         WednesdayCloseTime: 61200,
         IsClosedOnWednesday: false,
         ThursdayOpenTime: 32400,
         ThursdayCloseTime: 61200,
         IsClosedOnThursday: false,
         FridayOpenTime: 32400,
         FridayCloseTime: 61200,
         IsClosedOnFriday: false,
         SaturdayOpenTime: 36000,
         SaturdayCloseTime: 61200,
         IsClosedOnSaturday: false,
         SundayOpenTime: 36000,
         SundayCloseTime: 57600,
         IsClosedOnSunday: false,
         ExtensionProperties: undefined,
     }
      },
      {
        storName: "Città Essentials Glen Innes",
        address: `117 Apirana Avenue
        Glen Innes
        Auckland 1072
        NZL`,
        phone: "09 255 1525",
        emailAddress: "gleninnes@cittaessentials.com",
        locationNotes:undefined,
        stockistOf:`Città
        Città Essentials
        Compagnie De Provence
        Duralex
        Nude`,
        googleMapLink: "https://goo.gl/maps/81VzLgtFLgBfeBCp9",
        storeHours:{
            MondayOpenTime: 36000,
            MondayCloseTime: 57600,
            IsClosedOnMonday: false,
            TuesdayOpenTime: 36000,
            TuesdayCloseTime: 57600,
            IsClosedOnTuesday: false,
            WednesdayOpenTime: 36000,
            WednesdayCloseTime: 57600,
            IsClosedOnWednesday: false,
            ThursdayOpenTime: 36000,
            ThursdayCloseTime: 57600,
            IsClosedOnThursday: false,
            FridayOpenTime: 36000,
            FridayCloseTime: 57600,
            IsClosedOnFriday: false,
            SaturdayOpenTime: 36000,
            SaturdayCloseTime: 57600,
            IsClosedOnSaturday: false,
            SundayOpenTime: 36000,
            SundayCloseTime: 57600,
            IsClosedOnSunday: false,
            ExtensionProperties: undefined,
     }
      }
 ];



export default CittaStoreLocationMobile;
